import React from 'react';
import { ActivityIndicator, Pressable, PressableProps, Text, View } from 'react-native';

import { type ButtonProps, SIZES } from '.';

import { getIconByName } from 'components/Icons';

type OutlineButtonProps = Omit<ButtonProps, 'gradientVariant' | 'variant' | 'backgroundColor'> & {
  borderColor?: string;
};

const OutlineButton = React.forwardRef<PressableProps, OutlineButtonProps>(
  (
    {
      borderColor = '#1240ff',
      children,
      iconType,
      iconStyle,
      isFullWidth = false,
      isLoading = false,
      size = 'md',
      style,
      textStyle,
      textTransform,
      rounded = false,
      ...rest
    },
    ref
  ) => {
    const Icon = iconType ? getIconByName(iconType) : null;

    return (
      <Pressable
        ref={ref}
        role="button"
        style={[
          {
            borderWidth: 3,
            borderColor: 'red',
            backgroundColor: 'transparent',
            width: isFullWidth ? '100%' : undefined,
            borderRadius: rounded ? 50 : undefined,
            paddingHorizontal: 20,
          },
          style,
        ]}
        {...rest}>
        {Icon && (
          <View style={{ marginRight: children ? 4 : 0 }}>
            <Icon {...iconStyle} />
          </View>
        )}
        {children && (
          <Text
            style={[
              {
                fontSize: SIZES[size],
                textTransform,
                marginVertical: 4,
              },
              textStyle,
            ]}>
            {children}
          </Text>
        )}
        {isLoading && <ActivityIndicator color="white" size="small" style={{ marginLeft: 4 }} />}
      </Pressable>
    );
  }
);

export default OutlineButton;
